import { ISandDollarsBalanceResponse } from '@src/api/sandDollars.api'
import { ChainId, NATIVE_TOKEN_ADDRESS, NULLADDRESS } from '@src/configs/chainInfo'
import { ISandDollarsData } from '@src/types/order'
import { Balance } from '@src/utils/balance'

/**
 * Creates a Balance object from sand dollars data
 * @param data The sand dollars data from the quote or API response
 * @returns A Balance object representing the sand dollars
 */
export const createSandDollarsBalance = (data?: ISandDollarsData | ISandDollarsBalanceResponse): Balance | null => {
    if (!data) {
        return null
    }

    try {
        let amount: string
        let decimals: number

        // Check if it's ISandDollarsBalanceResponse (from API)
        if ('balance' in data) {
            amount = data.balance
            decimals = data.decimals
        } else {
            // It's ISandDollarsData (from quote)
            amount = data.amount
            decimals = data.decimals
        }

        // Create a balance object with appropriate properties
        const balance = new Balance({
            name: 'Sand Dollars',
            symbol: 'SD',
            bigintValue: BigInt(amount),
            decimals,
            chainId: 0, // Not chain-specific
            address: NULLADDRESS, // Using NULLADDRESS as placeholder
        })

        return balance
    } catch (error) {
        console.error('Error creating Sand Dollars balance:', error)
        return null
    }
}
